/* coldnumbers — email alert sign-up box
 * ---------------------------------------------------------------------------
 * Put  <div data-cn-signup></div>  anywhere and include this script. Options
 * (data attributes on that div):
 *   data-source="home"            where the sign-up happened (GA4 + database)
 *   data-game="powerball"         pre-tick one game ("both" by default)
 *   data-variant="compact"        email + button only (default "full")
 *   data-numbers-from="#suggestedBalls"
 *                                 offer to check the numbers shown in that
 *                                 element (.ball-w = white, last .ball = special)
 *   data-title / data-text        override the heading and intro line
 *   data-push="off"               no "📲 Phone alerts" button under the form
 *
 * Bot protection: hidden trap field, minimum fill time, Cloudflare Turnstile
 * (once TURNSTILE_SITE_KEY is set below), server-side rate limit, throwaway-
 * domain block, MX check — and a confirmation email before anything is sent.
 *
 * Phone alerts (Web Push, see PUSH.md): every box gets a "📲 Phone alerts"
 * button that uses the same game / jackpot choices; <div data-cn-push></div>
 * renders a stand-alone phone-alerts card (account page). The service worker
 * (/sw.js, registered by assets/pwa.js) shows the notifications.
 */
(function () {
  'use strict';
  if (window.__cnSignup) return;
  window.__cnSignup = true;

  var ENDPOINT = 'https://nfyikscwiccugssahnex.supabase.co/functions/v1/newsletter';
  var APIKEY = 'sb_publishable_R7OnsLjl4fXReEMhGG31rw_uCeTxPEM'; // public key (safe in the browser)
  // Cloudflare Turnstile site key (public). Leave empty until it is set up — see EMAIL.md.
  var TURNSTILE_SITE_KEY = '';
  // Phone alerts: the push edge function and the PUBLIC half of the VAPID key
  // pair (the private half is a Supabase secret; both must match — PUSH.md).
  var PUSH_ENDPOINT = 'https://nfyikscwiccugssahnex.supabase.co/functions/v1/push';
  var VAPID_PUBLIC_KEY = 'BAfBS6eebDPsWa76yDRJvV2GrpJ1HTjXZsmvYlWanthiLJg8wV_cJkWj4-15zTe09yvktL0ueglr8nG_5pQmEYE';

  function track(name, p) { try { if (typeof window.track === 'function') window.track(name, p || {}); } catch (e) {} }
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) e.setAttribute(k, attrs[k]);
    if (html != null) e.innerHTML = html;
    return e;
  }

  var CSS = '' +
    '.cn-su{background:var(--card,#111827);border:1px solid var(--border,#334155);border-radius:12px;padding:16px 18px;margin:18px 0;color:var(--text,#e5e7eb)}' +
    '.cn-su h3{margin:0 0 4px;font-size:16px}' +
    '.cn-su p.cn-su-intro{margin:0 0 12px;font-size:13px;color:var(--text2,#94a3b8);line-height:1.5}' +
    '.cn-su-row{display:flex;gap:8px;flex-wrap:wrap}' +
    '.cn-su input[type=email]{flex:1;min-width:210px;padding:10px 12px;border-radius:8px;border:1px solid var(--border,#334155);background:var(--bg2,#0b1220);color:var(--text,#e5e7eb);font:inherit;font-size:14px}' +
    '.cn-su button{padding:10px 18px;border-radius:8px;border:0;background:var(--accent,#00b4d8);color:#fff;font-weight:700;font-size:13px;cursor:pointer}' +
    '.cn-su button[disabled]{opacity:.6;cursor:default}' +
    '.cn-su-opts{display:flex;flex-wrap:wrap;gap:6px 16px;margin:10px 0 0;font-size:12.5px;color:var(--text2,#94a3b8)}' +
    '.cn-su-opts label{display:inline-flex;align-items:center;gap:6px;cursor:pointer}' +
    '.cn-su-opts select{padding:3px 6px;border-radius:6px;border:1px solid var(--border,#334155);background:var(--bg2,#0b1220);color:var(--text,#e5e7eb);font:inherit;font-size:12px}' +
    '.cn-su-nums{font-family:"IBM Plex Mono",monospace;font-weight:600;color:var(--text,#e5e7eb)}' +
    '.cn-su-trap{position:absolute!important;left:-9999px!important;width:1px;height:1px;overflow:hidden}' +
    '.cn-su-status{margin-top:10px;font-size:13px;min-height:18px}' +
    '.cn-su-status.ok{color:var(--ok,#06d6a0)}.cn-su-status.err{color:var(--bad,var(--danger,#ef476f))}' +
    '.cn-su-fine{font-size:11px;color:var(--text3,#64748b);margin-top:8px}' +
    '.cn-su-fine a{color:var(--text2,#94a3b8)}' +
    '.cn-su-ts{margin-top:8px}' +
    '.cn-push{margin-top:12px;padding-top:12px;border-top:1px solid var(--border,#334155)}' +
    '.cn-push.cn-push-flat{margin-top:0;padding-top:0;border-top:0}' +
    '.cn-push-row{display:flex;align-items:center;gap:8px 12px;flex-wrap:wrap}' +
    '.cn-su .cn-push-btn{background:transparent;border:1px solid var(--accent,#00b4d8);color:var(--accent,#00b4d8)}' +
    '.cn-su .cn-push-btn.on{border-color:var(--ok,#06d6a0);color:var(--ok,#06d6a0)}' +
    '.cn-su .cn-push-off{background:none;border:0;padding:4px 2px;color:var(--text2,#94a3b8);font-weight:500;text-decoration:underline}' +
    '.cn-push-note{font-size:12.5px;color:var(--text2,#94a3b8)}' +
    '.cn-push-ios{margin-top:10px;padding:10px 12px;border-radius:8px;background:var(--bg2,#0b1220);border:1px solid var(--border,#334155);font-size:13px;line-height:1.55}' +
    '.cn-push-ios ol{margin:6px 0 0;padding-left:20px}' +
    '.cn-push-status{margin-top:8px;font-size:13px;min-height:0}' +
    '.cn-push-status.ok{color:var(--ok,#06d6a0)}.cn-push-status.err{color:var(--bad,var(--danger,#ef476f))}';

  // ── Turnstile (loaded on first interaction, only if configured) ──────────
  var tsLoading = null;
  function loadTurnstile() {
    if (!TURNSTILE_SITE_KEY) return Promise.resolve(null);
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (tsLoading) return tsLoading;
    tsLoading = new Promise(function (resolve) {
      window.__cnTsReady = function () { resolve(window.turnstile); };
      var s = el('script', { src: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=__cnTsReady', async: '' });
      s.onerror = function () { resolve(null); };
      document.head.appendChild(s);
    });
    return tsLoading;
  }

  // Shared with the account page's email-login form (Supabase Auth CAPTCHA).
  window.cnTurnstile = {
    siteKey: TURNSTILE_SITE_KEY,
    getToken: function (holder, action) {
      if (!TURNSTILE_SITE_KEY || !holder) return Promise.resolve(null);
      return loadTurnstile().then(function (ts) {
        if (!ts) return null;
        return new Promise(function (resolve) {
          if (holder.__tsId != null) { try { ts.remove(holder.__tsId); } catch (e) {} }
          holder.__tsId = ts.render(holder, {
            sitekey: TURNSTILE_SITE_KEY, size: 'flexible', appearance: 'interaction-only', action: action || 'login',
            callback: resolve, 'error-callback': function () { resolve(null); }
          });
        });
      });
    }
  };

  function readNumbers(sel, game) {
    try {
      var box = sel && document.querySelector(sel);
      if (!box) return null;
      var all = box.querySelectorAll('.ball');
      var white = [].map.call(box.querySelectorAll('.ball-w'), function (b) { return parseInt(b.textContent, 10); })
        .filter(function (n) { return n > 0; });
      var last = all[all.length - 1];
      var special = last && !last.classList.contains('ball-w') ? parseInt(last.textContent, 10) : NaN;
      if (white.length !== 5 || !(special > 0)) return null;
      return { game: game, white: white, special: special };
    } catch (e) { return null; }
  }

  function render(box) {
    if (box.__cnDone) return;
    box.__cnDone = true;
    var source = box.getAttribute('data-source') || location.pathname.replace(/^\/|\.html$/g, '') || 'home';
    var game = box.getAttribute('data-game') || 'both';
    var compact = box.getAttribute('data-variant') === 'compact';
    var numsFrom = box.getAttribute('data-numbers-from');
    var numGame = game === 'megamillions' ? 'megamillions' : 'powerball';
    var title = box.getAttribute('data-title') || '📬 Get results by email';
    var text = box.getAttribute('data-text') ||
      'Winning numbers in your inbox after every draw' + (numsFrom ? ', with a check of your numbers' : '') +
      '. Optional jackpot alerts. Free, confirm by email, unsubscribe anytime.';
    var started = Date.now();
    var uid = 'cnsu' + Math.random().toString(36).slice(2, 8);

    box.classList.add('cn-su');
    box.setAttribute('data-track-section', 'email signup');
    box.innerHTML =
      '<h3>' + title + '</h3><p class="cn-su-intro">' + text + '</p>' +
      '<form novalidate>' +
      '<div class="cn-su-row">' +
      '<input type="email" name="email" required autocomplete="email" placeholder="you@example.com" aria-label="Email address" id="' + uid + '-e">' +
      '<button type="submit">Send me results</button>' +
      '</div>' +
      '<div class="cn-su-trap" aria-hidden="true"><label>Website <input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>' +
      '<div class="cn-su-opts">' +
      (compact ? '' :
        '<label><input type="checkbox" name="pb"' + (game !== 'megamillions' ? ' checked' : '') + '> Powerball</label>' +
        '<label><input type="checkbox" name="mm"' + (game !== 'powerball' ? ' checked' : '') + '> Mega Millions</label>' +
        '<label>Jackpot alert <select name="jackpot" aria-label="Jackpot alert">' +
        '<option value="">off</option><option value="300000000">$300M+</option><option value="500000000" selected>$500M+</option>' +
        '<option value="1000000000">$1B+</option></select></label>') +
      (numsFrom ? '<label><input type="checkbox" name="nums" checked> Check these numbers: <span class="cn-su-nums">…</span></label>' : '') +
      '<label><input type="checkbox" name="age" required> I am 18 or older</label>' +
      '</div>' +
      '<div class="cn-su-ts"></div>' +
      '<div class="cn-su-status" role="status" aria-live="polite"></div>' +
      '<div class="cn-su-fine">We email you once to confirm. <a href="' + rel('privacy.html') + '">Privacy</a> · we never sell your email.</div>' +
      '</form>';

    var form = box.querySelector('form');
    var status = box.querySelector('.cn-su-status');
    var btn = form.querySelector('button');

    // 📲 Phone alerts with the same choices as the email form
    if (box.getAttribute('data-push') !== 'off') {
      var pushHolder = el('div');
      box.appendChild(pushHolder);
      pushControls(pushHolder, source, function () {
        return {
          pb: compact ? game !== 'megamillions' : form.pb.checked,
          mm: compact ? game !== 'powerball' : form.mm.checked,
          jackpot: compact ? null : (form.jackpot.value ? Number(form.jackpot.value) : null),
          age: form.age.checked
        };
      }, compact ? 'Or get a notification on this device after each draw.'
                 : 'Or get notifications on this device for the games ticked above.');
    }
    var numsLabel = box.querySelector('.cn-su-nums');
    function showNums() {
      if (!numsLabel) return;
      var n = readNumbers(numsFrom, numGame);
      numsLabel.textContent = n ? n.white.join(' ') + ' + ' + n.special : '(run the analyzer first)';
    }
    showNums();
    if (numsFrom) {
      var target = document.querySelector(numsFrom);
      if (target && window.MutationObserver) new MutationObserver(showNums).observe(target, { childList: true, subtree: true });
    }

    var tsWidget = null, tsToken = '';
    function ensureTurnstile() {
      if (!TURNSTILE_SITE_KEY || tsWidget !== null) return;
      tsWidget = false;
      loadTurnstile().then(function (ts) {
        if (!ts) return;
        tsWidget = ts.render(box.querySelector('.cn-su-ts'), {
          sitekey: TURNSTILE_SITE_KEY, size: 'flexible', appearance: 'interaction-only', action: 'signup',
          callback: function (t) { tsToken = t; }, 'expired-callback': function () { tsToken = ''; }
        });
      });
    }
    form.addEventListener('focusin', ensureTurnstile);

    function say(msg, kind) { status.textContent = msg; status.className = 'cn-su-status' + (kind ? ' ' + kind : ''); }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = (form.email.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { say('Please enter a valid email address.', 'err'); form.email.focus(); return; }
      if (!form.age.checked) { say('Please confirm you are 18 or older.', 'err'); return; }
      var pb = compact ? game !== 'megamillions' : form.pb.checked;
      var mm = compact ? game !== 'powerball' : form.mm.checked;
      var jackpot = compact ? null : (form.jackpot.value ? Number(form.jackpot.value) : null);
      if (!pb && !mm && !jackpot) { say('Pick at least one: Powerball, Mega Millions or a jackpot alert.', 'err'); return; }
      if (TURNSTILE_SITE_KEY && !tsToken) { ensureTurnstile(); say('One moment — finishing a quick bot check, then press the button again.', ''); return; }
      var nums = numsFrom && form.nums && form.nums.checked ? readNumbers(numsFrom, numGame) : null;

      btn.disabled = true; btn.textContent = 'Sending…'; say('');
      track('signup_submit', { source: source });
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: APIKEY },
        body: JSON.stringify({
          action: 'subscribe', email: email, source: source, interest: pb && !mm ? 'powerball' : mm && !pb ? 'megamillions' : 'all',
          alerts: { pb: pb, mm: mm }, jackpot_min: jackpot, numbers: nums ? [nums] : null,
          age_ok: true, website: form.website.value, elapsed_ms: Date.now() - started, turnstile: tsToken || undefined
        })
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (j) {
          if (j && j.ok) {
            say(j.message || 'Almost done — check your inbox to confirm.', 'ok');
            form.email.value = '';
            track('newsletter_signup', { source: source, status: j.status || 'pending', games: (pb ? 'pb' : '') + (mm ? 'mm' : ''), jackpot: jackpot ? 'on' : 'off', numbers: nums ? 'yes' : 'no' });
          } else {
            say((j && j.message) || 'Something went wrong. Please try again.', 'err');
            track('signup_error', { source: source, error: (j && j.error) || 'unknown' });
          }
        })
        .catch(function () { say('Network problem — please try again.', 'err'); track('signup_error', { source: source, error: 'network' }); })
        .then(function () {
          btn.disabled = false; btn.textContent = 'Send me results';
          if (tsWidget && window.turnstile) { try { window.turnstile.reset(tsWidget); } catch (e) {} tsToken = ''; }
        });
    });
  }

  // ── 📲 Phone alerts (Web Push) ──────────────────────────────────────────
  var ua = navigator.userAgent || '';
  var IS_IOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  function standalone() {
    try { return navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches; } catch (e) { return false; }
  }
  function platform() { return IS_IOS ? 'ios' : /Android/i.test(ua) ? 'android' : 'desktop'; }
  function pushSupported() {
    return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window && window.isSecureContext !== false;
  }
  function keyBytes(b64) {
    var s = (b64 + '==='.slice(0, (4 - b64.length % 4) % 4)).replace(/-/g, '+').replace(/_/g, '/');
    var raw = atob(s), out = new Uint8Array(raw.length);
    for (var i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
    return out;
  }
  function sameKey(sub) {
    try {
      var k = sub.options && sub.options.applicationServerKey;
      if (!k) return true;
      var a = new Uint8Array(k), b = keyBytes(VAPID_PUBLIC_KEY);
      if (a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
      return true;
    } catch (e) { return true; }
  }
  function fail(code) { var e = new Error(code); e.code = code; return e; }
  function timeout(p, ms, code) {
    return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(fail(code)); }, ms); })]);
  }
  // Works with both the promise and the old callback form (older Safari).
  function askPermission() {
    return new Promise(function (resolve) {
      var r = Notification.requestPermission(function (p) { resolve(p); });
      if (r && typeof r.then === 'function') r.then(resolve, function () { resolve('default'); });
    });
  }
  // The worker is normally registered by assets/pwa.js on page load.
  function swRegistration() {
    return timeout(navigator.serviceWorker.getRegistration('/').then(function (reg) {
      if (reg && reg.active) return reg;
      if (!reg) navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' }).catch(function () {});
      return navigator.serviceWorker.ready;
    }), 15000, 'sw');
  }
  function currentSubscription() {
    if (!pushSupported() || Notification.permission !== 'granted') return Promise.resolve(null);
    return navigator.serviceWorker.getRegistration('/').then(function (reg) {
      return reg ? reg.pushManager.getSubscription() : null;
    }).catch(function () { return null; });
  }
  function postPush(body) {
    return fetch(PUSH_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: APIKEY },
      body: JSON.stringify(body)
    }).catch(function () { throw fail('network'); })
      .then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  var PUSH_MSG = {
    denied: 'Notifications are blocked for coldnumbers on this device. Allow them in your browser’s site settings (on iPhone: Settings → Notifications → coldnumbers), then tap again.',
    dismissed: 'No problem — tap again whenever you want alerts.',
    unsupported: 'This browser can’t show notifications from websites. Try Chrome, Edge, Firefox or Safari — or get the results by email.',
    ios_old: 'Phone alerts need iOS / iPadOS 16.4 or later. You can get the results by email instead.',
    sw: 'Couldn’t finish setting up alerts on this device. Reload the page and try again.',
    subscribe: 'Your browser couldn’t register for notifications. Please try again later, or get the results by email.',
    network: 'Network problem — please try again.',
    age: 'Please confirm you are 18 or older (tick the box above).',
    nothing: 'Pick at least one: Powerball, Mega Millions or a jackpot alert.'
  };

  // Renders the button + status into `holder`. getPrefs() → {pb, mm, jackpot, age}
  function pushControls(holder, source, getPrefs, note) {
    holder.classList.add('cn-push');
    holder.setAttribute('data-track-section', 'phone alerts');
    holder.innerHTML =
      '<div class="cn-push-row">' +
      '<button type="button" class="cn-push-btn">📲 Phone alerts</button>' +
      '<span class="cn-push-note">' + note + '</span>' +
      '<button type="button" class="cn-push-off" hidden>Turn off</button>' +
      '</div>' +
      '<div class="cn-push-ios" hidden><strong>On iPhone and iPad, alerts work from the home-screen app:</strong><ol>' +
      '<li>Tap <strong>Share</strong> <span aria-hidden="true">(□↑)</span> → <strong>Add to Home Screen</strong>.</li>' +
      '<li>Open coldnumbers from your home screen and tap <strong>📲 Phone alerts</strong> again.</li>' +
      '</ol><span class="cn-push-note">Needs iOS / iPadOS 16.4 or later.</span></div>' +
      '<div class="cn-push-status" role="status" aria-live="polite"></div>';
    var btn = holder.querySelector('.cn-push-btn');
    var off = holder.querySelector('.cn-push-off');
    var ios = holder.querySelector('.cn-push-ios');
    var status = holder.querySelector('.cn-push-status');
    var busy = false;

    function say(msg, kind) { status.textContent = msg || ''; status.className = 'cn-push-status' + (kind ? ' ' + kind : ''); }
    function setOn(on) {
      btn.classList.toggle('on', !!on);
      btn.textContent = on ? '📲 Phone alerts on ✓ · update' : '📲 Phone alerts';
      off.hidden = !on;
    }
    function error(code, msg) {
      say(msg || PUSH_MSG[code] || PUSH_MSG.subscribe, code === 'dismissed' ? '' : 'err');
      track('push_error', { source: source, error: code, platform: platform() });
    }
    currentSubscription().then(function (sub) { if (sub) setOn(true); });

    btn.addEventListener('click', function () {
      if (busy) return;
      var p = getPrefs();
      if (!p.pb && !p.mm && !p.jackpot) { say(PUSH_MSG.nothing, 'err'); return; }
      if (!p.age) { say(PUSH_MSG.age, 'err'); return; }
      if (IS_IOS && !standalone()) {
        ios.hidden = false; say('');
        track('push_error', { source: source, error: 'ios_needs_home_screen', platform: 'ios' });
        return;
      }
      if (!pushSupported()) { error(IS_IOS ? 'ios_old' : 'unsupported'); return; }
      if (Notification.permission === 'denied') { error('denied'); return; }

      busy = true; btn.disabled = true; say('Setting up alerts…');
      // Ask first, synchronously inside the tap (Safari requires a user gesture).
      askPermission().then(function (perm) {
        if (perm !== 'granted') throw fail(perm === 'denied' ? 'denied' : 'dismissed');
        return swRegistration();
      }).then(function (reg) {
        return reg.pushManager.getSubscription().then(function (sub) {
          if (sub && sameKey(sub)) return sub;
          return (sub ? sub.unsubscribe().catch(function () {}) : Promise.resolve()).then(function () {
            return reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: keyBytes(VAPID_PUBLIC_KEY) })
              .catch(function () { throw fail('subscribe'); });
          });
        });
      }).then(function (sub) {
        return postPush({
          action: 'subscribe', subscription: sub.toJSON(), source: source, key: VAPID_PUBLIC_KEY,
          alerts: { pb: !!p.pb, mm: !!p.mm }, jackpot_min: p.jackpot || null, age_ok: true
        });
      }).then(function (j) {
        if (!j || !j.ok) { error((j && j.error) || 'server', j && j.message); return; }
        setOn(true);
        say((j.message || 'Phone alerts are on.') + (j.welcome === 'sent' ? ' We just sent a test notification.' : ''), 'ok');
        track('push_subscribe', {
          source: source, status: j.status || 'subscribed', games: (p.pb ? 'pb' : '') + (p.mm ? 'mm' : ''),
          jackpot: p.jackpot ? 'on' : 'off', platform: platform(), standalone: standalone() ? 'yes' : 'no'
        });
      }).catch(function (e) {
        error((e && e.code) || 'subscribe');
      }).then(function () { busy = false; btn.disabled = false; });
    });

    off.addEventListener('click', function () {
      if (busy) return;
      busy = true; off.disabled = true;
      currentSubscription().then(function (sub) {
        if (!sub) return null;
        var endpoint = sub.endpoint;
        return sub.unsubscribe().catch(function () {}).then(function () {
          return postPush({ action: 'unsubscribe', endpoint: endpoint }).catch(function () {});
        });
      }).then(function () {
        setOn(false); say('Phone alerts are off on this device.', 'ok');
        track('push_unsubscribe', { source: source, platform: platform() });
      }).catch(function () { say(PUSH_MSG.network, 'err'); })
        .then(function () { busy = false; off.disabled = false; });
    });
  }

  // Stand-alone card: <div data-cn-push data-source="account"></div>
  function renderPushCard(box) {
    if (box.__cnDone) return;
    box.__cnDone = true;
    var source = box.getAttribute('data-source') || location.pathname.replace(/^\/|\.html$/g, '') || 'home';
    var game = box.getAttribute('data-game') || 'both';
    box.classList.add('cn-su');
    box.innerHTML =
      '<h3>' + (box.getAttribute('data-title') || '📲 Phone alerts') + '</h3>' +
      '<p class="cn-su-intro">' + (box.getAttribute('data-text') ||
        'A notification on this phone or computer after each draw: the winning numbers and the next jackpot. Free, no email needed, turn off anytime.') + '</p>' +
      '<div class="cn-su-opts" style="margin:0 0 10px">' +
      '<label><input type="checkbox" name="pb"' + (game !== 'megamillions' ? ' checked' : '') + '> Powerball</label>' +
      '<label><input type="checkbox" name="mm"' + (game !== 'powerball' ? ' checked' : '') + '> Mega Millions</label>' +
      '<label>Jackpot alert <select name="jackpot" aria-label="Jackpot alert">' +
      '<option value="">off</option><option value="300000000">$300M+</option><option value="500000000" selected>$500M+</option>' +
      '<option value="1000000000">$1B+</option></select></label>' +
      '<label><input type="checkbox" name="age"> I am 18 or older</label>' +
      '</div><div class="cn-push-flat"></div>';
    var q = function (n) { return box.querySelector('[name="' + n + '"]'); };
    pushControls(box.lastChild, source, function () {
      return { pb: q('pb').checked, mm: q('mm').checked, jackpot: q('jackpot').value ? Number(q('jackpot').value) : null, age: q('age').checked };
    }, 'Works on Android, computers, and iPhone (from the home screen).');
  }

  // relative link that works from /, /states/ and /draw/<game>/
  function rel(p) {
    var me = document.currentScript || document.querySelector('script[src*="signup.js"]');
    var src = me ? me.getAttribute('src') || '' : '';
    var m = src.match(/^((?:\.\.\/)*)assets\//);
    return (m ? m[1] : '') + p;
  }

  function init() {
    if (!document.getElementById('cn-su-css')) document.head.appendChild(el('style', { id: 'cn-su-css' }, CSS));
    [].forEach.call(document.querySelectorAll('[data-cn-signup]'), render);
    [].forEach.call(document.querySelectorAll('[data-cn-push]'), renderPushCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
